"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMembershipApiClient = createMembershipApiClient;
const customer_client_1 = require("./customer.client");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createMembershipApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    const customerApiClient = (0, customer_client_1.customerApiClientFactory)(apiHost, options);
    async function fetchMembershipsByPartnerIdAndMembershipNumber(partnerId, membershipNumber) {
        const customer = await customerApiClient.getCustomer({ partnerId, customerNumber: membershipNumber });
        return customer;
    }
    async function findPaymentMethodsForAMembershipAndAPartner(partnerId, membershipNumber) {
        const paymentMethods = await customerApiClient.getCustomerPaymentMethods({ partnerId, customerNumber: membershipNumber });
        return paymentMethods;
    }
    async function findShippingAddressesForAMembershipAndAPartner(partner_id, membership_number) {
        try {
            const response = await client.get(`/v1/partners/${partner_id}/memberships/${membership_number}/shipping-addresses`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        fetchMembershipsByPartnerIdAndMembershipNumber,
        findPaymentMethodsForAMembershipAndAPartner,
        findShippingAddressesForAMembershipAndAPartner
    };
}
